// import "@carbon/web-components/es/components/multi-select/index.js";
// import "@carbon/web-components/es/components/date-picker/index.js";

import Listing from "./components/Listing";
import { format } from "date-fns";
import flatpickr from "flatpickr";

export const listingFilters = (element) => {
    // const picker = document.querySelector("cds-date-picker");
    // const calendar = picker?.calendar;
    const picker = document.querySelector("#date-picker");

    const calendar = flatpickr(picker, {
        inline: true,
        mode: "range",
        minDate: "today",
        monthSelectorType: "static",
        locale: {
            firstDayOfWeek: 1,
        },
        onChange: function (selectedDates, dateStr, instance) {
            instance.element.value = dateStr.replace(" to ", "/");

            if (picker?.value) {
                intervals.forEach((item) => {
                    item.checked = false;
                });

                let dates = picker.value.split("/");
                let date_display = [];
                dates.forEach((date) => {
                    date_display.push(format(date, "dd/MM/yy"));
                });
                date_display = date_display.join(" - ");
                datepicker_button.textContent = date_display;
                selected_range.textContent = date_display;
            }
        },
    });
    const intervals = document.querySelectorAll('[name="interval"]');
    const datepicker_button = document.querySelector(
        "#datepicker-button .button-text",
    );
    const selected_range = document.getElementById("selected-range");
    const status_bar = document.querySelector("[data-status-message]");
    const no_results = document.querySelector("#noResultsSection");

    if (element) {
        let listing = new Listing({
            root: element,
            listing: "events",
            daterange: "dates",
            callback: () => {
                // Filters status bar

                setTimeout(() => {
                    let field_value_names = {};
                    Object.keys(listing.query).forEach((item) => {
                        let values = listing.query[item][0].split(",");

                        let key = item == "interval" ? listing.daterange : item;
                        field_value_names[key] = [];

                        if (key == listing.daterange) {
                            let button = document.createElement("button");
                            button.name = key;
                            button.classList.add("btn--pill");
                            button.dataset["value"] = key;
                            button.textContent = selected_range.textContent;
                            field_value_names[key] = [button];
                        } else {
                            values.forEach((value) => {
                                let input = document.querySelector(
                                    `[value="${value}"]`,
                                );
                                let button = document.createElement("button");
                                button.name = key;
                                button.classList.add("btn--pill");
                                button.dataset["value"] = value;

                                if (input.labels) {
                                    button.textContent =
                                        input.labels[0].textContent;
                                } else {
                                    input = document.querySelector(
                                        `[selection-name][value="${value}"]`,
                                    );
                                    button.textContent = input.textContent;
                                }
                                field_value_names[key].push(button);
                            });
                        }
                    });

                    console.log("field_value_names", field_value_names);

                    // Reset container
                    status_bar.innerHTML = "";
                    Object.keys(field_value_names).forEach((name) => {
                        let text_node = "";
                        if (name == "dates") {
                            text_node = " on ";
                        } else if (name == "venue") {
                            text_node = " at ";
                        } else if (name == "genre") {
                            text_node = " in ";
                        } else if (name == "accessibility") {
                            text_node = " with ";
                        }
                        status_bar.appendChild(
                            document.createTextNode(text_node),
                        );
                        field_value_names[name].forEach(
                            (value, index, array) => {
                                if (
                                    array.length > 1 &&
                                    index == array.length - 1
                                ) {
                                    status_bar.appendChild(
                                        document.createTextNode(" and "),
                                    );
                                }
                                status_bar.appendChild(value);
                            },
                        );
                    });

                    if (Object.keys(field_value_names).length) {
                        document
                            .querySelector("[data-form-status]")
                            .classList.add("active");
                    } else {
                        document
                            .querySelector("[data-form-status]")
                            .classList.remove("active");
                    }

                    console.log(
                        "Hello",
                        document.querySelector(
                            "#feed-whats-on [data-no-results]",
                        ),
                    );
                    if (!listing.filtered.length) {
                        if (
                            !document.querySelector(
                                "#feed-whats-on [data-no-results]",
                            )
                        ) {
                            let noresults = no_results.content.cloneNode(true);
                            listing.container.before(noresults);
                        }
                    } else {
                        if (
                            document.querySelector(
                                "#feed-whats-on [data-no-results]",
                            )
                        ) {
                            document
                                .querySelector(
                                    "#feed-whats-on [data-no-results]",
                                )
                                .remove();
                        }
                    }
                    console.log("CALLBACK");
                }, 100);
            },
        });

        if (location.hash) {
            let hash = location.hash.replace(/#/, "");
            let venue = `venue-${hash}`;
            if (document.getElementById(venue)) {
                document.getElementById(venue).checked = true;
                listing.form.dispatchEvent(new Event("change"));
            }
        }

        // Active filters
        document.addEventListener("click", (e) => {
            let target = e.target;

            if (target.name == "venue") {
                location.hash = `#${target.value}`;
            } else {
                location.hash = "";
            }

            if (
                target.classList.contains("btn--pill") &&
                target.dataset.value
            ) {
                e.preventDefault();
                let input = document.querySelector(
                    `[value="${target.dataset.value}"]`,
                );

                if (input && input.labels) {
                    if (["radio", "checkbox"].includes(input.type)) {
                        input.checked = false;
                    } else {
                        input.value = "";
                    }
                } else if (target.name == "dates") {
                    intervals.forEach((item) => {
                        item.checked = false;
                        item.dispatchEvent(new Event("change"));
                    });
                } else {
                    input = document.querySelector(
                        `[selection-name][value="${target.dataset.value}"]`,
                    );

                    let multi_select = document.querySelector(
                        `cog-multi-select[name="${target.name}"]`,
                    );
                    let values = multi_select.getAttribute("value").split(",");
                    values = values.filter((x) => x != target.dataset.value);
                    multi_select.value = values.join(",");
                }

                listing.form.dispatchEvent(new Event("change"));
            }
        });

        listing.form.addEventListener("reset", (e) => {
            // Reset datepicker
            calendar.clear();

            // Reset datepicker dialog button text
            datepicker_button.textContent =
                datepicker_button.dataset.defaultText;
            selected_range.textContent = selected_range.dataset.defaultText;
            // Reset multi-select
            document.querySelectorAll("cog-multi-select").forEach((item) => {
                item.value = "";
            });

            // Hide filter status bar
            status_bar.classList.remove("active");
        });

        // Set datepicker options
        // calendar.open();
        // calendar.set("inline", true);
        // calendar.set("closeOnSelect", false);
        // console.log(calendar);

        // Dialogs
        // element.querySelectorAll("[data-dialog]").forEach((item) => {
        //     item.addEventListener("click", (e) => {
        //         e.preventDefault();

        //         let button = e.currentTarget;

        //         // Trigger datepicker upon opening the dialog
        //         if (button.id == "datepicker-button") {
        //             let dialog = document.getElementById(
        //                 e.currentTarget.dataset.dialog,
        //             );
        //             if (dialog.open) {
        //                 document
        //                     .querySelector("cds-date-picker-input")
        //                     .dispatchEvent(new Event("click"));
        //             }
        //         }
        //     });
        // });

        // Reset datepicker upon selecting an interval
        intervals.forEach((item) => {
            item.addEventListener("change", () => {
                calendar.clear();
                if (item.checked) {
                    datepicker_button.textContent =
                        item.labels[0].dataset.range;
                    selected_range.textContent = item.labels[0].dataset.range;
                } else {
                    datepicker_button.textContent =
                        datepicker_button.dataset.defaultText;
                    selected_range.textContent =
                        selected_range.dataset.defaultText;
                }
            });
        });

        // Reset intervals upon using the datepicker
        // document.addEventListener("cds-date-picker-changed", (e) => {
        //     if (picker?.value) {
        //         intervals.forEach((item) => {
        //             item.checked = false;
        //         });

        //         let dates = picker.value.split("/");
        //         let date_display = [];
        //         dates.forEach((date) => {
        //             date_display.push(format(date, "dd/MM/yy"));
        //         });
        //         date_display = date_display.join(" - ");
        //         datepicker_button.textContent = date_display;
        //         selected_range.textContent = date_display;
        //     }
        // });

        // The multi-select component doesn't trigger a change event
        // We're dispatching that once its options are selected
        document.addEventListener("cds-multi-select-selected", (e) => {
            let event = new Event("change");
            listing.form.dispatchEvent(event);
        });
    }
};

document.addEventListener("DOMContentLoaded", () => {
    const element = document.getElementById("whats-on-filters");
    if (element) {
        listingFilters(element);
    }
});
